import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import StockStatus from '../StockStatus';
import Price from '../Price';
import BuyButtonContainer from '../../Containers/BuyButton.container';
import WishListButton from '../WishList/WishListButton';
import ResponsiveImage from '../ResponsiveImage';
import useEcommerceDisabled from '../../Hooks/useEcommerceDisabled';

const ProductCard = (props) => {
  const {
    images,
    id: articleNumber,
    articleNumberLabel,
    name,
    boxQuantity,
    packageSize,
    price,
    url,
    parentCategory,
    isInStock,
    stockStatusDescripton,
    isAuthenticated,
    quantity,
    currency,
    stockMessage,
  } = props;
  const [ buyQuantity, setBuyQuantity ] = useState(0);
  const ecommerceDisabled = useEcommerceDisabled();

  return (
    <div className="product-card">
      {isAuthenticated && (
        <WishListButton
          noBorder={true}
          articleId={articleNumber}
          quantity={quantity}
        />
      )}
      {images && !!images.length && (
        <a href={url}>
          <ResponsiveImage {...images[0]} className="product-card__image" />
        </a>
      )}
      <a className="product-card__title-and-category" href={url}>
        {name && <span className="product-card__title">{name}</span>}
        {parentCategory && (
          <span className="product-card__category">{parentCategory}</span>
        )}
      </a>
      <div className="product-card__middle">
        <div className="product-card__artno-and-units">
          {articleNumberLabel && (
            <div className="product-card__artno">
              {translate('product.artno')}: <span>{articleNumberLabel}</span>
            </div>
          )}
          {boxQuantity && (
            <div className="product-card__units">
              {translate('product.units')}: <span>{boxQuantity}</span>
            </div>
          )}
        </div>
        {isAuthenticated && !ecommerceDisabled && (
          <StockStatus
            inStock={isInStock}
            description={stockStatusDescripton}
            showInfoBox={!isInStock}
            stockMessage={stockMessage}
          />
        )}
      </div>
      <div className="product-card__bottom">
        {isAuthenticated && !ecommerceDisabled && price && (
          <Price
            price={price}
            packageSize={packageSize}
            currency={currency}
            disableTierPriceTooltip={true}
            showForQuantity={buyQuantity}
          />
        )}
        {!ecommerceDisabled ? (
          <BuyButtonContainer
            articleNumber={articleNumber}
            buyButtonLabel={translate('product.add-to-cart')}
            packageSize={packageSize}
            disableTierPriceTooltip={true}
            onChangeQuantity={newQuantity => setBuyQuantity(newQuantity)}
          />
        ) : (
          <a href={url} className="product-card__anchor-button">
            {translate('product.view-product')}
          </a>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
